import React from 'react'
import classNames from 'classnames'
import { ButtonSize, getButtonSizeClasses } from '@/atoms/Button/ButtonUtil'
import { useDerivedAriaLabel } from '@/utils/reactUtils/reactChildrenUtils'
import { ButtonVariant, getVariantClasses } from './ButtonUtil'

export interface ButtonProps extends React.ComponentPropsWithRef<'button'> {
  variant: ButtonVariant
  size?: ButtonSize
  outline?: boolean
  danger?: boolean
}

export const Button = (props: ButtonProps) => {
  const { variant, size = 'standard', outline, className, children, danger, ...rest } = props
  const ariaLabel = useDerivedAriaLabel(props)

  return (
    <button
      {...rest}
      className={
        variant === 'plain'
          ? className
          : classNames(
              'btn',
              getButtonSizeClasses(size),
              getVariantClasses({ variant, outline, disabled: props.disabled, danger }),
              className,
            )
      }
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
}
